import { computed, watch } from "vue";
import { useStore } from "vuex";

import { defineStore } from "pinia";

import { convertToWindows, isMacOs } from "@/hooks/keyboard/normalizeShortcut";
import { updateShortcutConfigs } from "@/hooks/keyboard/shortcutRegistry";

import type {
  KeyboardShortcutOption,
  UserKeyboardShortcut,
} from "@/models/options";

export const useKeyboardShortcutsStore = defineStore(
  "keyboardShortcuts",
  () => {
    const { getters } = useStore();

    const userShortcuts = computed<Record<string, KeyboardShortcutOption>>(
      () => getters["options/userKeyboardShortcuts"]
    );

    const configuredShortcuts = computed<UserKeyboardShortcut[]>(() => {
      let list = Object.entries(userShortcuts.value).map(([key, value]) => ({
        ...value,
        key,
      }));
      if (!isMacOs) {
        list = convertToWindows(list);
      }
      return list;
    });

    const shortcutsByAction = computed(
      () => new Map(configuredShortcuts.value.map((sc) => [sc.action_name, sc]))
    );

    watch(
      configuredShortcuts,
      (s) => {
        updateShortcutConfigs(s);
      },
      { immediate: true }
    );

    return {
      userShortcuts,
      configuredShortcuts,
      shortcutsByAction,
    };
  }
);
